// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_12995","counter":"_982"};